module.exports = __webpack_public_path__ + "static/img/workers.45383ff2.png";